<template>
  <check class="icon" />
</template>

<script>
  import Check from './Check.vue'

  export default {
    name: 'Confirmation',
    components: {
      Check
    }
  }
</script>

<style lang="scss" scoped>
  svg.icon {
    color: color(success-500);
  }
</style>
